<template>
  <div>
    <p class="title" @click.stop="handleTerms">
      {{ $t('使用规则') }}
      <svg
        width="14px"
        height="14px"
        viewBox="0 0 48 48"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="common_icon_notes备份"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="common_icon_notes" fill-rule="nonzero">
            <rect
              id="Rectangle"
              fill-opacity="0"
              fill="#FFFFFF"
              x="0"
              y="0"
              width="48"
              height="48"
            ></rect>
            <g
              id="Group-37"
              transform="translate(3.789474, 3.789474)"
              fill="#000000"
            >
              <path
                d="M21.7151229,25.6141311 L21.7151229,25.0640636 C21.7151229,24.2874976 21.8769074,23.5756455 22.2328335,22.9285072 C22.5240457,22.3460827 22.9770425,21.7636582 23.5918239,21.2459476 C25.1125989,19.9193141 26.0185926,19.0780343 26.3098048,18.7221082 C27.1187277,17.6866869 27.5393676,16.3600534 27.5393676,14.7745646 C27.5393676,12.8331497 26.8922293,11.2800178 25.5979527,10.1475258 C24.3036761,8.98267682 22.6211165,8.43260927 20.5502739,8.43260927 C18.1558622,8.43260927 16.2791611,9.11210448 14.9201707,10.5034518 C13.5611803,11.8624423 12.8816851,13.7067864 12.8816851,16.0688412 L16.2791611,16.0688412 C16.2791611,14.6451369 16.5703734,13.5450018 17.1527979,12.7684359 C17.7999362,11.8300853 18.8677143,11.3770885 20.3237755,11.3770885 C21.4886245,11.3770885 22.426975,11.7006577 23.0741133,12.347796 C23.6888947,12.9949343 24.0124638,13.868571 24.0124638,15.001063 C24.0124638,15.8423428 23.6888947,16.6189088 23.1064702,17.3631178 L22.5564027,17.9778992 C20.5502739,19.7575295 19.3207112,21.084163 18.9000713,21.9901566 C18.4470745,22.8314364 18.252933,23.8668577 18.252933,25.0640636 L18.252933,25.6141311 L21.7151229,25.6141311 Z M19.9678495,31.9884434 C20.6149878,31.9884434 21.1974122,31.761945 21.650409,31.3413051 C22.1034058,30.8883083 22.3622612,30.3382407 22.3622612,29.6587455 C22.3622612,28.9792503 22.1357628,28.4291827 21.6827659,28.0085428 C21.2297691,27.555546 20.6473447,27.3614045 19.9678495,27.3614045 C19.3207112,27.3614045 18.7382867,27.555546 18.2852899,28.0085428 C17.8322931,28.4291827 17.6057947,28.9792503 17.6057947,29.6587455 C17.6057947,30.3058838 17.8322931,30.8559513 18.2852899,31.3089481 C18.7382867,31.761945 19.3207112,31.9884434 19.9678495,31.9884434 Z M20.2105263,37.4634146 C29.7390334,37.4634146 37.4634146,29.7390334 37.4634146,20.2105263 C37.4634146,10.6820192 29.7390334,2.957638 20.2105263,2.957638 C10.6820192,2.957638 2.957638,10.6820192 2.957638,20.2105263 C2.957638,29.7390334 10.6820192,37.4634146 20.2105263,37.4634146 Z M20.2105263,40.4210526 C9.04856085,40.4210526 0,31.3724918 0,20.2105263 C0,9.04856085 9.04856085,-7.10542736e-15 20.2105263,-7.10542736e-15 C31.3724918,-7.10542736e-15 40.4210526,9.04856085 40.4210526,20.2105263 C40.4210526,31.3724918 31.3724918,40.4210526 20.2105263,40.4210526 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </p>
    <!-- <TermsPopup v-model="showTerms" /> -->
  </div>
</template>

<script>
// import TermsPopup from './termsPopup';
import { getLocale } from '@/utils/locale';
export default {
  name: 'TermsOfUse',
  components: {
    // TermsPopup,
  },
  data() {
    return {
      showTerms: true,
    };
  },
  methods: {
    handleTerms() {
      window.open(`https://c-h5.didi-food.com/${getLocale()}/user-guide/terms`);
      // this.$termsPopup();
      // this.showTerms = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: 'Aspira Light';
  font-weight: 200;
  font-size: 12px;
  margin-top: 8px;
  cursor: pointer;
  svg {
    font-size: 13px;
    position: relative;
    font-weight: 200;
    top: 2px;
    left: 2px;
  }
}
</style>